module.exports = __webpack_public_path__ + "static/media/11.7ec49868.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/11.png
// module id = 751
// module chunks = 0